import { ImpersonationStatus, UserSettings } from '@/types/api/user';

export const clientFetchIsImpersonating = async (): Promise<ImpersonationStatus> => {
  const response = await fetch(`/api/user/is-impersonating`, { method: 'GET' });
  if (!response.ok) throw new Error('Failed to fetch impersonation status');
  const data: { isImpersonating: boolean | null } = await response.json();
  return data.isImpersonating;
};

export const clientFetchUserSettings = async (): Promise<UserSettings> => {
  const response = await fetch(`/api/user/settings`, { method: 'GET' });
  if (!response.ok) throw new Error('Failed to fetch user settings');
  const data = await response.json();
  return data;
};
